import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { BackButton2 } from '../../../../common/BackButton2';
import WidgetsSubmit from './WidgetsSubmit';
import CustomColorPicker from './CustomColorPicker';
import AccountSetupInputBox from '../../../../common/AccountSetupInputBox';
import AccountSetupButton from '../../../../common/AccountSetupButton';
import { HOSPITALITY_LIST, OTHER_LIST, RETAILER_LIST } from '../DATA';
import { useMenuContext } from '../../../../Contexts/MenuContext';

interface IProps {
  state: {
    website: string;
    websiteError: string;
    chatbotName: string;
    nameErr: string;
    listOfThemes: string[];
    selectedTheme: string;
    storedTheme: string;
  };
  isSubmit: boolean;
  isDisabled: boolean;
  setIsSubmit: (value: boolean) => void;
  handleState: (field: string, value: string) => void;
  handleCreateOrUpdateWidgets: any;
  isSettings: boolean | undefined;
  menu: string[];
}

const CreateWidgets = (props: IProps) => {
  const {
    state,
    isSubmit,
    isDisabled,
    handleState,
    setIsSubmit,
    handleCreateOrUpdateWidgets,
    isSettings,
    menu
  } = props;

  const navigate = useNavigate();
  const businessType = sessionStorage.getItem('businessType');
  const { menuList } = useMenuContext();

  const stepsList =
    businessType === 'Retail'
      ? RETAILER_LIST
      : businessType === 'Hospitality' && menuList.includes('Services')
        ? HOSPITALITY_LIST
        : OTHER_LIST;
  const stepNumber = stepsList.filter((data) => data.step === 'Widgets')[0].id;

  useEffect(() => {
    if (isSettings) {
      setIsSubmit(true);
    }
  }, [isSettings]);

  const handleSubmitWebsite = (e: any) => {
    e.preventDefault();
    handleCreateOrUpdateWidgets();
  };

  const handleGoBack = () => {
    if (isSubmit) {
      setIsSubmit(false);
    } else {
      navigate('/account-setup/faq');
    }
  };

  return (
    <div className="flex flex-col w-full h-full bg-[#1E1E1E] rounded-lg lg:px-0 md:pt-3 lg:pt-6 p-2 overflow-y-auto">
      {!isSettings && (
        <>
          <h2 className="lg:text-base md:text-base text-[14px] font-normal md:mb-[5px] mb-1 lg:ml-9 ml-[4px] md:ml-1">
            STEP {stepNumber}
          </h2>
          <div className="flex ml-[4px] md:ml-1 lg:mt-0 md:mt-1">
            <div className="lg:mt-1 md:mt-2 mt-1 mr-1 sm:pt-[3px] lg:pt-0">
              <BackButton2 onClick={handleGoBack} />
            </div>
            <h1 className="h-[39px] md:pt-1 lg:pt-0 lg:ml-0 lg:mt-2 md:mt-[10px] mt-1 lg:mb-[20px] mb-[14px] text-[16px] sm:leading-[29.18px] md:text-base lg:text-base  font-medium">
              Create Widgets
            </h1>
          </div>
        </>
      )}
      <div className={`${isSettings ? 'lg:ml-4' : 'lg:ml-9'} ml-[4px] md:ml-1 mb-0`}>
        <form>
          {businessType !== 'Retail' && (
            <div className=" md:w-1/2 mr-3">
              <label
                htmlFor="targetWebsite"
                className=" text-[#FFFFFF] block sm:text-[12px] sm:leading-[26.86px] md:text-sm md:leading-[30.86px] font-medium  md:mb-[5px] mb-1"
              >
                Your Website Name
              </label>
              <AccountSetupInputBox
                name="targetWebsite"
                type="text"
                value={state.website}
                placeholder="Enter Website"
                handleChange={(e) => handleState('website', e.target.value)}
                error={state.websiteError}
                disabled={isSettings ? false : isSubmit}
              />
            </div>
          )}
          <div className=" md:w-1/2 mr-3">
            <label
              htmlFor="targetWebsite"
              className=" text-[#FFFFFF] block sm:text-[12px] sm:leading-[26.86px] md:text-sm md:leading-[30.86px] font-medium  md:mb-[5px] mb-1"
            >
              Customization
            </label>
            <AccountSetupInputBox
              name="chatBotname"
              type="text"
              value={state.chatbotName}
              placeholder="Chat bot name"
              handleChange={(e) => handleState('chatbotName', e.target.value)}
              disabled={isSettings ? false : isSubmit}
              error={state.nameErr}
            />
          </div>
          <div className=" sm:w-full md:w-1/2">
            <label className=" text-[#FFFFFF] block sm:text-[12px] sm:leading-[26.86px] md:text-sm md:leading-[30.86px] font-medium  mb-[5px]">
              Chat bot Themes
            </label>
            <div>
              <div className=" md:flex  md:flex-start md:justify-around mt-[22px] mb-[17px] md:w-[40%] sm:w-[20%] w-full  gap-4  md:gap-5  md:h-8">
                <div className="grid grid-cols-8 640-767:grid-cols-10  gap-2 640-767:gap-[3rem] lg:gap-4 md:flex md:space-x-[9px] lg:space-x-[6px] xl:space-x-[18px] ">
                  {state.listOfThemes.map((color, index) => (
                    <div
                      key={index}
                      className={`w-6 h-6 md:w-[20px] md:h-[20px]  rounded-sm ${(!isSubmit || isSettings) && 'cursor-pointer'} ${color === state.selectedTheme && 'border-2 border-white'}`}
                      style={{ backgroundColor: color }}
                      onClick={() =>
                        !isSubmit || isSettings ? handleState('selectedTheme', color) : {}
                      }
                    />
                  ))}

                  <div className="flex">
                    <CustomColorPicker
                      handleState={handleState}
                      selectedTheme={state.selectedTheme}
                      listOfColor={state.listOfThemes}
                      isSubmit={isSubmit}
                      isSettings={isSettings}
                      storedTheme={state.storedTheme}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {businessType !== 'Retail' && (
            <div className="text-[12px] sm:leading-[26.86px] md:text-sm md:leading-[30.86px] font-normal w-full mb-[1px]">
              <h2 className="text-[12px] sm:leading-[26.86px] md:text-sm md:leading-[30.86px] font-bold mb-[15px] mt-[11px]">
                Integrate This Script to Enable Chatbot
              </h2>
              <p className="pr-4 mr-4">
                Insert the following script into your website within the{' '}
                <span className="text-blue-600">&lt;body&gt;</span> tag, right before the{' '}
                <span className="text-blue-600">&lt;div id=&quot;root&quot;&gt;&lt;/div&gt;</span>.
                This will enable the chatbot on your website and start tracking user interactions.
              </p>
            </div>
          )}

          {!isSubmit && businessType !== 'Retail' && (
            <div className={'flex justify-center'}>
              <AccountSetupButton
                isFormValid={true}
                btnText={'Genearate the script'}
                textColor="#FFFFFF"
                backGroundColor="#006BEA"
                onClick={handleSubmitWebsite}
              />
            </div>
          )}
        </form>
      </div>
      {isSubmit ? (
        <WidgetsSubmit
          handleCreateOrUpdateWidgets={handleCreateOrUpdateWidgets}
          isDisabled={isDisabled}
          isSettings={isSettings}
          businessType={businessType}
          selectedTheme={state.selectedTheme}
          menu={menu}
        />
      ) : (
        <>
          {businessType === 'Retail' && (
            <div className="flex gap-2 md:gap-4 absolute bottom-0 right-8">
              <AccountSetupButton
                isFormValid={true}
                btnText="Skip"
                textColor="#FFFFFF"
                backGroundColor="#1E1E1E"
                borderColor="#006BEA"
                onClick={() => navigate('/account-setup/integration')}
              />
              <AccountSetupButton
                disable={isDisabled}
                isFormValid={true}
                btnText={`${isSettings ? 'Update' : 'Next'}`}
                textColor="#FFFFFF"
                backGroundColor="#006BEA"
                borderColor="#006BEA"
                onClick={handleSubmitWebsite}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CreateWidgets;
